import React from "react";
import { connect } from "react-redux";
import { detalleSiniestro } from "./seguimiento.act";

const mapState = (state) => {
	return {
		 siniestro: state.siniestros.sinrepSelect,
		 seguimiento: state.siniestros.detalleSiniestro
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargarDetalle : (siniestro) => {
			dispatch(detalleSiniestro(siniestro));
		},
		addEvento: (evento) => {
			dispatch({ "type": "SINIESTROS_SET_EVENT", "evento": evento});
		}
	};
};

export class DetalleReparacion extends React.Component {
	state = {
		"progressLine":"progress-line close-progress",
	}
	
	componentWillReceiveProps(nextProps) {
		if(this.props.siniestro.codSiniestro != nextProps.siniestro.codSiniestro)
		{
			console.log("Se cargará de nuevo detalle de: "+ nextProps.siniestro.codSiniestro);
			this.props.cargarDetalle(nextProps.siniestro.codSiniestro);
		}
	}
	
	componentWillMount = () => {
		console.log("Se cargará detalle de: "+this.props.siniestro.codSiniestro);
		//this.props.siniestro;
		this.props.cargarDetalle(this.props.siniestro.codSiniestro);
	}
	
	toggle = (id,event) => {
		
		 $('#'+id).toggle();
		 
		if(id == "detalleSinMovil"){
			this.props.addEvento("Detalle-SReparacion");	
		}
		
		//Obtienen el atributo css
		var classCSS = event.target.classList;
		
		console.log(classCSS);
		
		if(classCSS.contains("glyphicon-chevron-down")){
			classCSS.remove("glyphicon-chevron-down");
			classCSS.add("glyphicon-chevron-up");
		}else if(classCSS.contains("glyphicon-chevron-up")){
			classCSS.remove("glyphicon-chevron-up");
			classCSS.add("glyphicon-chevron-down");
		}
	}

	render() {
		return <div>
		<div className="container">
			<div className="datos-siniestro-wrapper">
				<h4>Datos Siniestro</h4>
				<div className="card datos-siniestro">
					<h6><i><img src={require("../img/datos-siniestro.svg")}></img></i>Datos de siniestro</h6>
					<ul>
						<li>
							<p className="pull-left">No. Siniestro:</p>
							<p className="pull-right">{this.props.siniestro.codSiniestro}</p>
						</li>
						<li>
							<p className="pull-left">Marca:</p>
							<p className="pull-right">{this.props.siniestro.carroceriaVehiculo}</p>
						</li>
						<li>
							<p className="pull-left">Modelo:</p>
							<p className="pull-right">{this.props.siniestro.modelo}</p>
						</li>
					</ul>
					
					<div id="detalleSinMovil" style={{'display':'none','position':'relative','margin':'10px 0'}}>
						<div className="datos-siniestro">
							<h6><i><img src={require("../img/icon-repair.svg")}></img></i>Centro de reparación</h6>
							<ul>
								<li>
									<p className="pull-left">Nombre:</p>
									<p className="pull-right">{this.props.siniestro.nombreCdr}</p>
								</li>
								<li>
									<p className="pull-left">Dirección:</p>
									<p className="pull-right">{this.props.siniestro.direccionCdr}</p>
								</li>
								<li>
									<p className="pull-left">Teléfono</p>
									<p className="pull-right">{this.props.siniestro.numTelefonoCdr}</p>
								</li>
							</ul>
						</div>
						<div className="datos-siniestro ">
							<h6><i><img src={require("../img/siniestro-user.svg")}></img></i>Datos del supervisor</h6>
							<ul>
								<li>
									<p className="pull-left">Nombre:</p>
									<p className="pull-right">{this.props.siniestro.nombreSupervisor}</p>
								</li>
								<li>
									<p className="pull-left">Correo electrónico:</p>
									<p className="pull-right">{this.props.siniestro.idOperador}</p>
								</li>
							</ul>
						</div>
					</div>
					
				</div>

				<div className="card datos-siniestro hide-mobile">
					<h6><i><img src={require("../img/icon-repair.svg")}></img></i>Centro de reparación</h6>
					<ul>
						<li>
							<p className="pull-left">Nombre:</p>
							<p className="pull-right">{this.props.siniestro.nombreCdr}</p>
						</li>
						<li>
							<p className="pull-left">Dirección:</p>
							<p className="pull-right">{this.props.siniestro.direccionCdr}</p>
						</li>
						<li>
							<p className="pull-left">Teléfono</p>
							<p className="pull-right">{this.props.siniestro.numTelefonoCdr}</p>
						</li>
					</ul>
				</div>

				<div className="card datos-siniestro hide-mobile">
					<h6><i><img src={require("../img/siniestro-user.svg")}></img></i>Datos del supervisor</h6>
					<ul>
						<li>
							<p className="pull-left">Nombre:</p>
							<p className="pull-right">{this.props.siniestro.nombreSupervisor}</p>
						</li>
						<li>
							<p className="pull-left">Correo electrónico:</p>
							<p className="pull-right">{this.props.siniestro.idOperador}</p>
						</li>
					</ul>
				</div>
				<div className="progress-detalle card datos-siniestro show-mobile" style={{"overflow":"hidden"}}>
					<p className="pull-left"style={{"margin":"0"}}>DETALLE</p>
					<span className="glyphicon glyphicon-chevron-down pull-right" onClick={this.toggle.bind(this,'detalleSinMovil')}></span>
				</div>
			</div>

			<div className="seguimiento-wrapper">
				<h4>Seguimiento a la reparación</h4>
				<div className="progress-wrapper">
					<div className="progress-line finish-progress"></div>
					
					{this.props.seguimiento.map((item, i) =>
							<div key={i} className="progress-step">
							
						{ i != 0 &&
							<span className=""></span>
						}
						{ i == 0 &&
							<span className="en-progreso"></span>
						}  
							<div className="card step-card">
								<h6>{ item.tramoStatus }</h6>
								<div className="progress-info">
									<p><i><img src={require("../img/calendar.svg")}></img></i>Fecha: { item.fchVehEst.substring(0,10) }</p>
									<p><i><img src={require("../img/time.svg")}></img></i>Hora: { item.fchVehEst.substring(11) }</p>
								</div>
								{ item.tramo == "RPT" && 
								<div className="progress-detalle">
									<p className="pull-left">DETALLE</p>
									<span className="glyphicon glyphicon-chevron-down pull-right" onClick={this.toggle.bind(this,'paso'+i)}></span>
									<div id={'paso'+i} style={{'display':'none','position':'relative','margin':'10px 0'}}><p>Luego de la revisión detallada de la unidad, te informamos que ha sido declarada como pérdida total. Para conocer los siguientes pasos haz click <a href="https://www.gnp.com.mx/wps/wcm/connect/029e2320-2642-4d56-86d9-5a622480e08a/SA_047perdmayor_0915VD.pdf?MOD=AJPERES" target="_blank">aquí.</a></p></div>
								</div>
								}
								{ item.tramo == "RPD" && 
								<div className="progress-detalle">
									<p className="pull-left">DETALLE</p>
									<span className="glyphicon glyphicon-chevron-down pull-right" onClick={this.toggle.bind(this,'paso'+i)}></span>
									<div id={'paso'+i} style={{'display':'none','position':'relative','margin':'10px 0'}}><p>Luego de la revisión detallada de la unidad realizaremos el pago de daños. Para conocer los siguientes pasos haz click <a href="https://www.gnp.com.mx/wps/wcm/connect/029e2320-2642-4d56-86d9-5a622480e08a/SA_047perdmayor_0915VD.pdf?MOD=AJPERES" target="_blank">aquí.</a></p></div>
								</div>
								}
								{ item.tramo != "RPT" && item.tramo != "RPD" && item.mensajeCorto != null && 
								<div className="progress-detalle">
									<p className="pull-left">DETALLE</p>
									<span className="glyphicon glyphicon-chevron-down pull-right" onClick={this.toggle.bind(this,'paso'+i)}></span>
									<div id={'paso'+i} style={{'display':'none','position':'relative','margin':'10px 0'}}><p>{item.mensajeCorto}</p></div>
								</div>
								}
							</div>
						</div>
					)}
				</div>
			</div>
			
		</div>
		</div>
	}

}

export default connect(mapState, mapDispatch)(DetalleReparacion);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/detalleReparacion.cmpt.js